import {LOCALE_ID, NgModule, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {LayoutComponent} from './shared/common/layout/layout.component';
import {TrustpilotComponent} from './shared/common/layout/trustpilot/trustpilot.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NotFoundComponent} from './shared/common/layout/errors/not-found/not-found.component';
import {ProjectNotActiveComponent} from './shared/common/layout/errors/project-not-active/project-not-active.component';
import {HeaderComponent} from './shared/common/layout/header/header.component';
import {CookieBannerComponent} from './shared/common/layout/cookie-banner/cookie-banner.component';
import {ModalComponent} from './shared/common/layout/modal/modal.component';
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {SidebarComponent} from './shared/common/layout/sidebar/sidebar.component';
import {LeadGenerationComponent} from './steps/lead-generation/lead-generation.component';
import {ContractComponent} from './steps/contract/contract.component';
import {ActComponent} from './steps/act/act.component';
import {ValuesInDisputeComponent} from './steps/values-in-dispute/values-in-dispute.component';
import {DataGateComponent} from './steps/data-gate/data-gate.component';
import {IndexComponent} from './shared/common/index/index.component';
import {TitleStrategy} from "@angular/router";
import {ModalModule} from "ngx-bootstrap/modal";
import {AppRoutingModule} from "./app-routing.module";
import {ToastrModule} from "ngx-toastr";
import {DemoComponent} from './shared/demo/demo.component';
import {AccordionModule} from "ngx-bootstrap/accordion";
import {ThankYouLeadGenerationComponent} from './shared/common/thank-you/thank-you-lead-generation/thank-you-lead-generation.component';
import {ThankYouDatagateComponent} from './shared/common/thank-you/thank-you-datagate/thank-you-datagate.component';
import {TitleResolverService} from "./shared/services/title-resolver.service";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {ThankYouContractComponent} from './shared/common/thank-you/thank-you-contract/thank-you-contract.component';
import {ThankYouActComponent} from './shared/common/thank-you/thank-you-act/thank-you-act.component';
import {defineLocale} from 'ngx-bootstrap/chronos';
import {deLocale} from 'ngx-bootstrap/locale';
import {registerLocaleData} from "@angular/common";
import localeDe from '@angular/common/locales/de';
import {FormSwitchComponent} from './shared/forms/form-switch/form-switch.component';
import {GenerateTokensComponent} from './shared/demo/generate-tokens/generate-tokens.component';
import {NgxFileDropModule} from 'ngx-file-drop';
import {FilterByClaimStatusPipe} from "./shared/pipes/filter-by-claim-status.pipe";
import {FileUploadService} from './shared/forms/form-input-file/form-input-file.component';
import {SharedModule} from './shared/shared.module';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';

defineLocale('de', deLocale);

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    TrustpilotComponent,
    NotFoundComponent,
    ProjectNotActiveComponent,
    HeaderComponent,
    CookieBannerComponent,
    ModalComponent,
    SidebarComponent,
    LeadGenerationComponent,
    ContractComponent,
    ActComponent,
    ValuesInDisputeComponent,
    DataGateComponent,
    IndexComponent,
    DemoComponent,
    ThankYouLeadGenerationComponent,
    ThankYouDatagateComponent,
    ThankYouContractComponent,
    ThankYouActComponent,
    FormSwitchComponent,
    GenerateTokensComponent,
    FilterByClaimStatusPipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot(),
    ModalModule.forRoot(),
    AccordionModule.forRoot(),
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgxFileDropModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'de'},
    {provide: TitleStrategy, useClass: TitleResolverService},
    FileUploadService
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {
  constructor() {
    registerLocaleData(localeDe, 'de-DE')
  }
}
